import DepositHistoryPageContainer from "../../Component/DepositFund/DepositHistory/DepositHistory"

const DepositHistoryPage = () => {
  return (
    <div className='page-body'>
      <DepositHistoryPageContainer />
    </div>
  )
}

export default DepositHistoryPage